<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        data-follow-fill="currentColor"
        d="M512 952c-118 0-228.6-45.6-311.5-128.5S72 630 72 512s45.6-228.6 128.5-311.5S394 72 512 72c98.6 0 195.2 33.4 272 94 21.4 17.8 38.2 33.4 52.6 48.7v-36c0-13.4 10.3-25.2 24.6-28.1l.8-.2h2.8c13.4 0 25.2 10.3 28.1 24.6l.2.8v120.5c0 13.4-10.3 25.2-24.6 28.1l-.8.2H747.3c-16.6 0-28.3-11.6-28.3-28.3 0-13.4 10.3-25.2 24.6-28.1l.8-.2h63.7c-18.3-22.2-39.8-41.4-58.6-57.3-67.2-53.7-149.4-82.2-237.5-82.2-211.4 0-383.5 172-383.5 383.5 0 211.4 172 383.5 383.5 383.5 211.4 0 383.5-172 383.5-383.5 0-16.6 11.6-28.3 28.3-28.3 16.6 0 28.3 11.6 28.3 28.3 0 118-45.6 228.6-128.5 311.5C740.6 906.4 630 952 512 952zm0-235.3c-30.9 0-60.3-11.6-80.6-31.9l-88.2-88.2c-23.1-23.1-35.9-53.2-35.9-84.6 0-30.9 11.6-60.3 31.9-80.6l90.2-90.2c21.5-21.5 51.6-33.9 82.6-33.9 30.9 0 60.3 11.6 80.6 31.9l88.2 88.2c23.1 23.1 35.9 53.2 35.9 84.5 0 30.9-11.6 60.3-31.9 80.6l-88.2 88.2c-23.2 23.3-53.2 36-84.6 36zm-35-339.8L378.9 475c-17.9 17.9-18.7 47.8-1.7 66.5l100.4 100.4.5.8c9 14.5 23.4 17.5 33.8 17.5 12.9 0 25.4-6.4 33.7-11.8L645 549c9.7-9.7 15.1-22.9 15.1-37 0-12.4-5.9-24.5-11-32.5L646 478l-99-99c-9.5-9.5-22.8-14.9-36.4-14.9-11.8 0-23.2 4.1-32.1 11.4l-1.5 1.4z"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
